module.exports = __webpack_public_path__ + "static/media/payment_link_preview.0983f936.PNG";